import React from 'react';
import { getTeamList, deleteTeam } from '../../api/team'
import PageList from '../../components/PageListAPI'
import { useCan } from '../../hooks/useCan';
import { SLUGS } from '../../enum/permissions.enum';

export default function TeamList({ match, location, history }) {
  const can = useCan()
  return <div className='App-paper'>
    <PageList
      name='teamList'
      title='Бригады'
      columns={[
        { id: 'name', name: 'Наименование' },
        { id: 'master', name: 'Мастер' },
        { id: 'phone', name: 'Телефон для связи' },
      ]}
      createItem={can(SLUGS.PROJECT.TEAM.MANAGE)}
      deleteItem={can(SLUGS.PROJECT.TEAM.MANAGE)}
      loadAPI={{
        request: getTeamList,
        param: {
          id: match.params.idProject
        },
      }}
      deleteAPI={deleteTeam(match.params.idProject)}
      match={match}
      history={history}
      location={location}
    />
  </div>
}